import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Hide splash screen after typing animation completes
const hideSplashScreen = () => {
  const splashScreen = document.getElementById('splash-screen');
  if (splashScreen) {
    // Wait for typing animation (~1.5s) + fade transition + small pause
    setTimeout(() => {
      splashScreen.classList.add('hidden');
      // Remove from DOM after fade out
      setTimeout(() => {
        splashScreen.remove();
      }, 300);
    }, 1350);
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

// Hide splash screen when app is ready
hideSplashScreen();

reportWebVitals();
